// extracted by mini-css-extract-plugin
module.exports = {"items_wrapper":"items_wrapper--2JZsz","item":"item--3MY6y","remove_item":"remove_item--1nivX","add_item":"add_item--3ddcG","input_new_item":"input_new_item--K7qeC"};